import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'

import { Button, IconButton } from '../../components/transpais'
import Ticket from '../../components/transpais/TranspaisTicket'
import { BASE_URL } from '../../utilities/constants'

import {
  pinpadPayment,
  bookingSessionTickets,
  bookingSessionPayments,
  idleDoneTimerPaused,

} from '../../utilities/atoms'
import { useModal } from '../../contexts/modal.context'
import { usePinpad } from '../../contexts/pinpad.context'
import { useTimer } from '../../contexts/timer.context'

import '../../scss/Layout.scss'
import global from './SearchTicketGlobal.module.scss'
import styles from './PrintTicket.module.scss'
import { Helmet } from 'react-helmet'
import { useLogger } from '../../contexts/logger.context'
import { currency } from '../../components/transpais/helpers/currency'

const PrintTicket = () => {

  const {loggerDebug} = useLogger()
  const navigate = useNavigate()

  const printAll = useRef(false)
  const ticketsArea = useRef(null)
  const selectedTicket = useRef(null)
  const ticketsRefs = useRef([])
  const [idleDonePaused, setIdleDonePaused] = useAtom(idleDoneTimerPaused)

  const [wasPrinted, setWasPrinted] = useState(false)

  const [currentTicketsScroll, setCurrentTicketsScroll] = useState(0)
  const [showScrollBottom, setShowScrollBottom] = useState(false)
  const [showScrollTop, setShowScrollTop] = useState(false)
  const [dates, setDates] = useState()

  // Todos los atoms para reset
  const [bookingTickets, setBookingTickets] = useAtom(bookingSessionTickets)
  const [bookingPayments, setBookingPayments] = useAtom(bookingSessionPayments)
  const [payment, setPayment] = useAtom(pinpadPayment)

  const fechaSalida = bookingTickets[0]?.fechaSalida;
  const fecha = fechaSalida ? (fechaSalida.split(' ')[0]) : '-'
  const hora = fechaSalida ? (fechaSalida.split(' ')[1]) : '-'
  const {showTimer, hideTimer, setupTimer} = useTimer()

  const {reset} = usePinpad()
  const {showModal, hideModal, setupModal} = useModal()

  const exit = () => {
    setBookingTickets([])
    setPayment({})
    setBookingPayments({})
    reset()

    navigate(`${ BASE_URL }/`)
  }

  const printDone = () => {
    loggerDebug('Printing completed...', printAll, selectedTicket.current, ticketsRefs.current.length)
    if (printAll.current && selectedTicket.current < (ticketsRefs.current.length - 1)) {
      selectedTicket.current++
      ticketsRefs.current[selectedTicket.current].printTicket()
    } else {
      selectedTicket.current = 0
      printAll.current = false
      setWasPrinted(true)
    }
  }

  const askPrintAll = () => {
    setupModal({
      title: 'Imprimir',
      content: <p>Estás a punto de imprimir todos tus boletos, toma cada uno conforme vaya saliendo ¿deseas continuar
        con la impresión?</p>,
      actions: {
        positive: {
          title: 'Si',
          onClick: () => {
            printAll.current = true
            selectedTicket.current = 0
            ticketsRefs.current[selectedTicket.current].printTicket()
            hideModal()
          }
        },
        negative: {
          title: 'No',
          onClick: () => {
            //selectedTicket.current = null
            hideModal()
          }
        }
      }
    })
    showModal()
  }

  const askPrint = () => {
    setupModal({
      title: 'Imprimir',
      content: <p>Al parecer ya imprimiste este boleto, ¿deseas imprimirlo una vez más?</p>,
      actions: {
        positive: {
          title: 'Reimprimir',
          onClick: () => {
            console.log(ticketsRefs.current[selectedTicket.current])
            console.log(ticketsRefs.current)
            console.log(selectedTicket.current)
            ticketsRefs.current[selectedTicket.current].printTicket()
            selectedTicket.current = null
            hideModal()
          }
        },
        negative: {
          title: 'No',
          onClick: () => {
            selectedTicket.current = null
            hideModal()
          }
        }
      }
    })
    showModal()
  }

  const askExit = () => {
    setupModal({
      title: 'Atención',
      content: <p>No imprimiste tus boletos, puedes verlos en tu app Transpais, ¿deseas volver al inicio?</p>,
      styles: {
        buttonType: 'small',
      },
      actions: {
        positive: {
          title: 'Quedarme a imprimirlos',
          onClick: () => {
            hideModal()
          }
        },
        negative: {
          title: 'Volver al inicio sin imprimirlos',
          onClick: () => {
            hideModal()
            exit()
          }
        }
      }
    })
    showModal()
  }

  useEffect(() => {
    loggerDebug(ticketsArea.current.scrollTop)
    loggerDebug(ticketsArea.current.offsetHeight)
    loggerDebug(ticketsArea.current.scrollHeight)
    if (ticketsArea.current.scrollHeight > ticketsArea.current.offsetHeight) {
      setShowScrollBottom(true)
    }
  }, [ticketsArea])

  const handleScroll = (e) => {
    setCurrentTicketsScroll(ticketsArea.current.scrollTop)
  }

  useEffect(() => {
  })

  useEffect(() => {
    if (currentTicketsScroll > 0) {
      setShowScrollTop(true)
    } else {
      setShowScrollTop(false)
    }

    if ((ticketsArea.current.scrollTop + ticketsArea.current.offsetHeight) === ticketsArea.current.scrollHeight) {
      setShowScrollBottom(false)
    } else {
      setShowScrollBottom(true)
    }
  }, [currentTicketsScroll])

  useEffect(() => {
    setIdleDonePaused(false)
    hideTimer()
  }, [])

  return (
    <>
      <Helmet>
      </Helmet>
      <section className={ ['section-full', 'section-flex'].join(' ') }>
        <div className={ [global.top, styles.top].join(' ') }>
          <div className={ ['logo', 'small', styles.logo].join(' ') }>
            <figure className={ ['logo-image', 'logo-image-transpais-light'].join(' ') }/>
            <div className={ styles.thanks }>
              <h1>¡GRACIAS!</h1>
              <p>Imprime cada uno de tus boletos.</p>
            </div>
          </div>
          <div className={ styles.middle }>
            <div className={ styles.details }>
              <div className={ styles.tickets } ref={ ticketsArea } onScroll={ handleScroll }>
                { bookingTickets.map((ticket, i) => {
                  return <Ticket key={ i } ref={(element) => {
                    ticketsRefs.current[i] = element
                  } } ticket={ ticket } payment={ payment } confirmation={ bookingPayments }
                          printable={ true } ask={ () => {
                    selectedTicket.current = i
                    askPrint()
                  } } done={ printDone }/>
                })}
              </div>
              { showScrollTop && <div className={ styles.scrollTop }>
                <IconButton
                  type="neutral"
                  icon="chevron-up"
                  onClick={ () => {
                    ticketsArea.current.scrollBy({top: -300, behavior: 'smooth'})
                  } }
                />
              </div> }
              { showScrollBottom && <div className={ styles.scrollBottom }>
                <IconButton
                  type="neutral"
                  icon="chevron-down"
                  onClick={ () => {
                    ticketsArea.current.scrollBy({top: 300, behavior: 'smooth'})
                  } }
                />
              </div> }
            </div>
            <div className={ styles.resume }>
              <div className={ [styles.receipt].join(' ') }>
                <h1>Tu pago</h1>
                <div className={ styles.group }>
                  <p>Fecha</p>
                  <span className={ styles.data }>{ `${ fecha } ${ hora }` }</span>
                </div>
                <div className={ styles.group }>
                  <p>Referencia</p>
                  <span className={ styles.data }>{ payment.reference }</span>
                </div>
                <div className={ styles.multiGroup }>
                  <div className={ styles.group }>
                    <p>Operación</p>
                    <span className={ styles.data }>{ payment.foliocpagos }</span>
                  </div>
                  <div className={ styles.group }>
                    <p>Importe</p>
                    <span className={ styles.data }>{ payment?.amount ? currency(payment.amount) : '-' }</span>
                  </div>
                </div>
                <p className={ styles.disclaimer }>Por este pagaré me obligo incondicionalmente a pagar a la orden del
                  banco emisor el importe de este título en los términos del contrato suscrito para el uso de esta
                  tarjeta de crédito en el caso de operaciones con tarjeta de debito, expresamente reconozco y acepto
                  este recibo es el comprobante de la operación realizada, misma que se consigna en el anverso y tendrá
                  pleno valor probatorio y fuerza legal, en virtud de que lo firme personalmente y/o digite mi numero de
                  identificacion personal como firma electrónica el cual es exclusivo de mi responsabilidad manifestando
                  plena conformidad al respecto.</p>
                <Button onClick={ askPrintAll } type="neutral">Imprimir todos</Button>
              </div>
            </div>
          </div>
        </div>
        <footer className={ global.bottom }>
          <div>
          </div>
          <div className={ global.middle }>
            <Button onClick={ () => {
              if (wasPrinted) {
                exit()
              } else {
                askExit()
              }
            } } type="positive" right-icon="house">Listo</Button>
          </div>
          <div>
          </div>
        </footer>
      </section>
    </>
  )
}

export default PrintTicket
